export type IEventsService = ReturnType<typeof eventsServiceFactory>;

/* @ngInject */
export function eventsServiceFactory(
  $rootScope,
  bitApi,
  heightCalc,
  sampleEvent,
) {
  const ready = false;
  let artist = '';
  let showDescription = false;
  const result = {
    status: false,
    events: [],
    processedEvents: [],
  };
  const local = {
    status: false,
  };

  return {
    ready,
    local,
    getResult,
    getEvents,
    getLocalEvents,
    allEvents,
    updateArtistName,
    updateDescriptionSetting,
    eventCount,
  };

  function getResult() {
    return result;
  }

  function normalizeEvent(event) {
    const { offers = [] } = event;
    const ticket = offers[0] || {};
    const ticketStatus = event.ticket_status || ticket.status;
    const ticketUrl = event.ticket_url || ticket.url;
    const ticketType = event.ticket_type || ticket.type;

    return {
      ...event,
      ticketStatus,
      ticketUrl,
      ticketType,
      url: event.facebook_rsvp_url || event.url,
    };
  }

  function getEvents(_artist) {
    const getEventsPromise = _artist
      ? bitApi.getEvents(_artist)
      : sampleEvent.getSampleEvent();
    return getEventsPromise.then(function(data) {
      result.events = data.map(normalizeEvent);
      result.status = true;
      return result.events;
    });
  }

  function renderLocalEvents() {
    heightCalc.lengthenWidget();
    result.status = false;
    local.status = true;
    heightCalc.setLocal(true);
    result.events = [];

    if (!artist) {
      updateEvents([]);
      return;
    }
    bitApi.getLocalEvents(artist).then(function(data) {
      updateEvents(data.map(normalizeEvent));
    });
  }

  function getLocalEvents() {
    if (!local.status) {
      renderLocalEvents();
    }
  }

  function allEvents() {
    if (local.status || !result.status) {
      heightCalc.lengthenWidget();
      result.status = false;
      local.status = false;
      heightCalc.setLocal(false);
      return getEvents(artist).then(function(data) {
        updateEvents(data);
      });
    }
  }

  function updateArtistName(name) {
    if (artist !== name) {
      artist = name;
      result.status = false;
      if (local.status) {
        renderLocalEvents();
      } else {
        allEvents();
      }
    }
  }

  function updateDescriptionSetting(setting) {
    if (showDescription !== setting) {
      showDescription = setting;
      result.status = false;
      if (local.status) {
        renderLocalEvents();
      } else {
        allEvents();
      }
    }
  }

  function updateEvents(newEvents) {
    result.events = [];
    result.events = newEvents;
    processEvents();
    $rootScope.$emit('new-events');
  }

  function processEvents() {
    result.processedEvents = result.events.map(event => processEvent(event));
    result.status = true;
    heightCalc.scrollInit();
  }

  function processEvent(event) {
    const processed = angular.extend({}, event);
    if (processed.venue.country === 'United States') {
      processed.venue.country = processed.venue.region;
    }
    processed.showDetails = false;
    if (showDescription) {
      const detailsArray = [];
      if (event.description) {
        detailsArray.push(event.description);
      }
      if (event.artists && event.artists.length > 1) {
        const artistsString = event.artists
          .map(_artist => _artist.name)
          .join(', ');

        const artists = `Artists: ${artistsString}`;
        detailsArray.push(artists);
      }

      if (detailsArray.length > 0) {
        processed.details = detailsArray.join('<br/>');
        if (processed.details.length >= 260) {
          processed.details = processed.details.substring(0, 260).concat('...');
        }
        processed.showDetails = true;
      } else {
        processed.showDetails = false;
      }
    }
    return processed;
  }

  function eventCount() {
    return result.processedEvents.length;
  }
}
